import { render, staticRenderFns } from "./reaWin.vue?vue&type=template&id=623b3488&scoped=true&"
import script from "./reaWin.vue?vue&type=script&lang=js&"
export * from "./reaWin.vue?vue&type=script&lang=js&"
import style0 from "./reaWin.vue?vue&type=style&index=0&id=623b3488&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b3488",
  null
  
)

export default component.exports